<template>
  <v-system-bar
    v-if="isViewingAsRole"
    color="amber darken-2"
    dark
    app
    fixed
    height="36"
  >
    <v-icon small class="mr-2">mdi-eye</v-icon>
    Visualizando como: <strong class="mx-1">{{ viewAsRoleTranslated || viewAsRoleName }}</strong>
    <v-spacer></v-spacer>
    <v-btn x-small text dark @click="clearViewAs">
      Voltar ao meu cargo
    </v-btn>
  </v-system-bar>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'ViewAsRoleBanner',
  computed: {
    ...mapState('App', ['viewAsRoleName', 'viewAsRoleTranslated']),
    isViewingAsRole() {
      return !!this.viewAsRoleName
    },
  },
  methods: {
    ...mapActions('App', ['clearViewAsRole']),
    clearViewAs() {
      this.clearViewAsRole()
      window.location.reload()
    },
  },
}
</script>
